module.exports = __webpack_public_path__ + "img/header-5.e9660166.jpg";